<template>
  <b-card
    v-if="sites.length"
    no-body
    class="card-company-table"
  >
    <b-table
      :per-page="pagination.perPage"
      :current-page="pagination.currentPage"
      :items="sites"
      responsive
      striped
      hover
      :fields="fields"
      class="mb-0"
    >
      <template #cell(label)="data">
        <div class="d-flex align-items-center primary">
          <span class="text-primary" @click="selectSite(data.item.idsite)">{{ data.item.label }}</span>
          <i class="feather icon-link text-danger" @click="openLink(data.item.main_url)" style="margin-left: 8px" />
        </div>
      </template>

      <template #cell(nb_visits)="data">
        <div class="d-flex align-items-center justify-content-end">
          <span>{{ numeralFormat(data.item.nb_visits) }}</span>
        </div>
      </template>

      <template #cell(nb_pageviews)="data">
        {{ numeralFormat(data.item.nb_pageviews) }}
      </template>

      <template #cell(revenue)="data">
        {{ numeralFormat(data.item.revenue, '$ 0,0.00') }}
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.currentPage"
      :total-rows="pagination.totalRows"
      :per-page="pagination.perPage"
      align="center"
      size="sm"
      class="my-1"
    />
  </b-card>
</template>

<script>
import numeral from 'numeral'
import store from '@/store'
import { initPagination } from '@/libs/helpers'

export default {
  data() {
    return {
      fields: [
        { key: 'label', label: 'WEBSITE' },
        { key: 'nb_visits', label: 'VISITS', class: 'text-right' },
        { key: 'nb_pageviews', label: 'PAGEVIEWS', class: 'text-right' },
        { key: 'revenue', label: 'REVENUE', class: 'text-right' }
      ],
      pagination: initPagination()
    }
  },
  computed: {
    sites() {
      return store.state.app.allSites
    }
  },
  methods: {
    numeralFormat(value, format = '0,0') {
      return numeral(value).format(format)
    },
    openLink(link) {
      window.open(link,'_blank')
    },
    selectSite(idsite) {
      store.commit('app/SET_APP_STATE', { idsite })
      this.$router.push({ name: 'dashboard'})
      console.log(idsite)
    }
  },
  mounted() {
    this.pagination.totalRows = this.sites.length
  }
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

</style>
